import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestSubCategoryDto, RequestCategoryDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-requestsubcategory-container',
  templateUrl: './requestsubcategory-container.component.html',
  styleUrls: ['./requestsubcategory-container.component.scss']
})
export class RequestSubCategoryContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  requestcategorys$: Observable<RequestCategoryDto[]>;
  requestsubcategorys$: Observable<RequestSubCategoryDto[]>;
  loading: boolean;
  isLoadingRequestCategory$: Observable<boolean>;
  isLoadingRequestSubCategory$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingRequestCategory$ = this.gatwayFacade.isLoadingGateway("RequestCategory");
    this.isLoadingRequestSubCategory$ = this.gatwayFacade.isLoadingGateway("RequestSubCategory");

    this.requestcategorys$ = this.gatwayFacade.loadGateway("RequestCategory");
    this.requestsubcategorys$ = this.gatwayFacade.loadGateway("RequestSubCategory");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteRequestSubCategory(deletedValue: any) {
    this.gatwayFacade.remove("RequestSubCategory", deletedValue);
  }

// this method control both the create and update
  onSubmitRequestSubCategory(formValue: any) {
    const pullData = formValue.RequestSubCategorys;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllRequestSubCategory = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllRequestSubCategory.push(pullData[i]);
    }
  }

// check if the addAllRequestSubCategory array is not empty, then dispatch the data to the store
   if(addAllRequestSubCategory.length > 0) {
    this.gatwayFacade.add('RequestSubCategory', addAllRequestSubCategory);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('RequestSubCategory', allUpdates, ['id']);
   }
  }


}
